// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface RelatedItemMetadata
 */
export interface RelatedItemMetadata {
    /**
     * 
     * @type {string}
     * @memberof RelatedItemMetadata
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedItemMetadata
     */
    type: RelatedItemMetadataTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RelatedItemMetadata
     */
    pathway?: string;
}

export function RelatedItemMetadataFromJSON(json: any): RelatedItemMetadata {
    return {
        'id': json['id'],
        'type': json['type'],
        'pathway': !exists(json, 'pathway') ? undefined : json['pathway'],
    };
}

export function RelatedItemMetadataToJSON(value?: RelatedItemMetadata): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'type': value.type,
        'pathway': value.pathway,
    };
}

/**
* @export
* @enum {string}
*/
export enum RelatedItemMetadataTypeEnum {
    AnnotatedVideo = 'annotated_video',
    Assignment = 'assignment',
    Assessment = 'assessment',
    Audio = 'audio',
    Book = 'book',
    CaseStudy = 'case_study',
    Cluster = 'cluster',
    Document = 'document',
    LxText = 'lx_text',
    Image = 'image',
    Interactive = 'interactive',
    LxVideo = 'lx_video',
    Narrative = 'narrative',
    Pathway = 'pathway',
    Question = 'question',
    Simulation = 'simulation',
    TeachingGuide = 'teaching_guide',
    Text = 'text',
    Video = 'video',
    Unknown = 'unknown',
    Link = 'link'
}


